import ScrollReveal from "./ScrollReveal";

const SectionHeading = ({
    eyebrow,
    title,
    description,
    align = "center",
    className = "",
}) => {
    const alignClass =
        align === "left"
            ? "text-left"
            : align === "right"
              ? "text-right"
              : "text-center mx-auto";

    return (
        <ScrollReveal className={`mb-12 md:mb-16 max-w-3xl ${alignClass} ${className}`}>
            {eyebrow && (
                <span className="section-eyebrow">{eyebrow}</span>
            )}
            <h2 className="section-title">{title}</h2>
            {description && (
                <p className="section-description">{description}</p>
            )}
        </ScrollReveal>
    );
};

export default SectionHeading;
